




























/**
 * External dependencies.
 */
import { Component, Prop, Vue } from 'vue-property-decorator'
import { UserData } from '@/store/authentication/interfaces/UserData'

/**
 * Internal dependencies.
 */

@Component
export default class UserInfo extends Vue {
  @Prop({ type: Object, required: true }) user: UserData
  @Prop({ type: Boolean, default: false }) makeClickable: boolean
}
